import React, { Component } from "react";
import { connect } from "react-redux";
import NoContent, { NO_FORMLIST } from "NoContent";
import Pagination from "react-js-pagination";
import { DropdownButton, Dropdown } from "react-bootstrap";
import _ from "lodash";
import {
  dynamicFormModal,
  updateFomeName,
  updateFormList,
  fetchFormBuilder,
} from "FormBuilderAction";
import { fetchSettings, fetchTickets } from "TicketAction";
import { fetchUsersCategory } from "DashboardUserAction";
import { fetchCountries } from "DashboardMenuAction";
import {
  itemCount,
  DEVELOPMENT_TYPE,
  screenHeightLeftFromTop,
} from "Constants";
import AddForm from "./add-form";
import EditForm from "./edit-form";
import FormList from "./form-list-item";
import Loader from "Loader";
import LocaleStrings from "Languages";

class FormBuilder extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pageNumber: 1,
      loading: true,
      desc: LocaleStrings.preparingCheckoutForm,
    };
  }

  componentDidMount() {
    this.props.fetchFormBuilder(this.props.session, 0, (callback) => {
      this.setState({ loading: false });
    });
    this.props.fetchSettings(this.props.session);
    this.props.fetchTickets(this.props.session);
    this.props.fetchUsersCategory(this.props.session);
    this.props.fetchCountries(this.props.session);
  }

  openModal = (e) => {
    var newObj = [];
    var formName = "";
    var fixedObj = [];

    if (e === "checkout") {
      fixedObj = [
        {
          key: "textinput",
          defaultfields: "fixed",
          required: false,
          maxlen: "250",
          label: "Email",
          name: "email",
          id: "email",
          header: "Input",
        },
        {
          key: "textinput",
          defaultfields: "fixed",
          required: false,
          maxlen: "250",
          label: "First Name",
          name: "firstname",
          id: "firstname",
          header: "Input",
        },
        {
          key: "textinput",
          defaultfields: "fixed",
          required: false,
          maxlen: "250",
          label: "Last Name",
          name: "lastname",
          id: "lastname",
          header: "Input",
        },
        // {
        //   key: "interestcheckboxes",
        //   defaultfields: "fixed",
        //   required: false,
        //   label: "Interest",
        //   name: "interest",
        //   id: "interest",
        //   header: "Multi Select",
        //   options: [
        //     { value: "software", text: "Software" },
        //     { value: "automation", text: "Automation" },
        //     { value: "gaming", text: "Gaming" },
        //     { value: "it", text: "IT" },
        //   ],
        // },
      ];
      newObj = [
        {
          key: "textarea",
          defaultfields: true,
          isactive: true,
          required: false,
          maxlen: "2000",
          label: "Bio",
          name: "biography",
          id: "biography",
          header: "Textarea",
          taborder: 1,
        },
        {
          key: "textinput",
          defaultfields: true,
          isactive: true,
          required: false,
          maxlen: "250",
          label: "Company",
          name: "company",
          id: "company",
          header: "Input",
          taborder: 2,
        },
        {
          key: "textinput",
          defaultfields: true,
          isactive: true,
          required: false,
          maxlen: "250",
          label: "Designation",
          name: "designation",
          id: "designation",
          header: "Input",
          taborder: 3,
        },
        {
          key: "singlecheckbox",
          defaultfields: true,
          isactive: true,
          required: false,
          label:
            "Networking/GDPR Consent (This will enable you to share your profile and connect with other users.)",
          name: "isnetworking",
          id: "isnetworking",
          header: "Checkbox",
          taborder: 4,
        },
        // {key:'checkboxes',defaultfields:true,isactive: true,required:false,label:'Interest',name:'interest',id:'interest',header:'Checkbox',taborder:4,options:[{value:'software', text:'Software'},{value:'automation', text:'Automation'},{value:'gaming', text:'Gaming'},{value:'it', text:'IT'},]},
        {
          key: "textinput",
          defaultfields: true,
          isactive: false,
          required: false,
          maxlen: "250",
          label: "Phone Number",
          name: "phonenumber",
          id: "phonenumber",
          header: "Input",
          taborder: 5,
        },
        {
          key: "textinput",
          defaultfields: true,
          isactive: true,
          required: false,
          maxlen: "250",
          label: "Facebook",
          name: "facebook",
          id: "facebook",
          header: "Input",
          taborder: 6,
        },
        {
          key: "textinput",
          defaultfields: true,
          isactive: true,
          required: false,
          maxlen: "250",
          label: "Twitter",
          name: "twitter",
          id: "twitter",
          header: "Input",
          taborder: 7,
        },
        {
          key: "textinput",
          defaultfields: true,
          isactive: true,
          required: false,
          maxlen: "250",
          label: "Linkedin",
          name: "linkedin",
          id: "linkedin",
          header: "Input",
          taborder: 8,
        },

        {
          key: "singlecheckbox",
          defaultfields: true,
          isactive: true,
          required: false,
          label: "Terms & Conditions",
          name: "termsconditions",
          id: "termsconditions",
          header: "Checkbox",
          taborder: 9,
        },
      ];
      formName = "Attendee Form";
    } else if (e === "exhibitor") {
      fixedObj = [
        {
          key: "file",
          defaultfields: "fixed",
          filetype: "image",
          required: false,
          maxupload: "1",
          label: "Upload Banner",
          name: "banner",
          id: "banner",
          header: "File",
          note: "(Recommended size: 566px * 368px)",
          maxuploadsize: 100,
        },
        {
          key: "file",
          defaultfields: "fixed",
          filetype: "image",
          required: false,
          maxupload: "1",
          label: "Upload Logo",
          name: "logo",
          id: "logo",
          header: "File",
          note: "(Recommended size: 400px *220px)",
          maxuploadsize: 100,
        },
        {
          key: "textinput",
          defaultfields: "fixed",
          required: true,
          maxlen: "250",
          label: "Exhibitor/Company Name",
          name: "name",
          id: "name",
          header: "Input",
        },
        {
          key: "textarea",
          defaultfields: "fixed",
          required: false,
          maxlen: "1000",
          label: "About/Bio",
          name: "about",
          id: "about",
          header: "Textarea",
        },
      ];
      newObj = [
        {
          key: "dropdown",
          defaultfields: true,
          isactive: true,
          required: false,
          label: "Industry",
          name: "industry",
          id: "industry",
          header: "Dropdown",
          hasCondition: false,
          taborder: 1,
          options: [
            {
              value: "drugs_pharmaceuticals",
              text: "Drugs & Pharmaceuticals",
              displayfields: "",
            },
            {
              value: "hospital_diagnostics",
              text: "Hospital & Diagnostics",
              displayfields: "",
            },
            {
              value: "food_beverages",
              text: "Food & Beverages",
              displayfields: "",
            },
            {
              value: "industrialplants_machinery",
              text: "Industrial Plants & Machinery",
              displayfields: "",
            },
            {
              value: "industrialsupplies",
              text: "Industrial Supplies",
              displayfields: "",
            },
            {
              value: "building_construction",
              text: "Building & Construction",
              displayfields: "",
            },
            {
              value: "apparel_garments",
              text: "Apparel & Garments",
              displayfields: "",
            },
            {
              value: "electronics_electrical",
              text: "Electronics & Electrical",
              displayfields: "",
            },
            {
              value: "packagingmachines_goods",
              text: "Packaging Machines & Goods",
              displayfields: "",
            },
            {
              value: "chemicalsdyes_solvents",
              text: "Chemicals, Dyes & Solvents",
              displayfields: "",
            },
            {
              value: "mechanicalparts_spares",
              text: "Mechanical Parts & Spares",
              displayfields: "",
            },
            {
              value: "labinstruments_supplies",
              text: "Lab Instruments & Supplies",
              displayfields: "",
            },
            {
              value: "furniture_supplies",
              text: "Furniture & Supplies",
              displayfields: "",
            },
            {
              value: "automobileparts_spares",
              text: "Automobile, Parts & Spares",
              displayfields: "",
            },
            {
              value: "agriculture_farming",
              text: "Agriculture & Farming",
              displayfields: "",
            },
            {
              value: "housewares_supplies",
              text: "Housewares & Supplies",
              displayfields: "",
            },
            {
              value: "metalsalloys_Minerals",
              text: "Metals, Alloys & Minerals",
              displayfields: "",
            },
            {
              value: "hand_machinetools",
              text: "Hand & Machine Tools",
              displayfields: "",
            },
            {
              value: "handicrafts_decoratives",
              text: "Handicrafts & Decoratives",
              displayfields: "",
            },
            {
              value: "kitchenutensils_appliances",
              text: "Kitchen Utensils & Appliances",
              displayfields: "",
            },
            {
              value: "textilesyarn_fabrics",
              text: "Textiles, Yarn & Fabrics",
              displayfields: "",
            },
            {
              value: "books_stationery",
              text: "Books & Stationery",
              displayfields: "",
            },
            {
              value: "cosmetics_personalcare",
              text: "Cosmetics & Personal Care",
              displayfields: "",
            },
            {
              value: "hometextile_furnishing",
              text: "Home Textile & Furnishing",
              displayfields: "",
            },
            {
              value: "engineeringservices",
              text: "Engineering Services",
              displayfields: "",
            },
            {
              value: "gemsjewelry_astrology",
              text: "Gems, Jewelry & Astrology",
              displayfields: "",
            },
            {
              value: "computer_itsolutions",
              text: "Computer & IT Solutions",
              displayfields: "",
            },
            {
              value: "fashionaccessories_gear",
              text: "Fashion Accessories & Gear",
              displayfields: "",
            },
            {
              value: "herbal_ayurvedicproduct",
              text: "Herbal & Ayurvedic Product",
              displayfields: "",
            },
            {
              value: "securitysystems_services",
              text: "Security Systems & Services",
              displayfields: "",
            },
            {
              value: "sportsgoodstoys_games",
              text: "Sports Goods, Toys & Games",
              displayfields: "",
            },
            {
              value: "telecomequipment_goods",
              text: "Telecom Equipment & Goods",
              displayfields: "",
            },
            {
              value: "paper_paperproducts",
              text: "Paper & Paper Products",
              displayfields: "",
            },
            {
              value: "bagsbelts_wallets",
              text: "Bags, Belts & Wallets",
              displayfields: "",
            },
            {
              value: "mediapr_publishing",
              text: "Media, PR & Publishing",
              displayfields: "",
            },
            {
              value: "marblegranite_stones",
              text: "Marble, Granite & Stones",
              displayfields: "",
            },
            {
              value: "eventplanner_organizer",
              text: "Event Planner & Organizer",
              displayfields: "",
            },
            {
              value: "it_telecomservices",
              text: "IT & Telecom Services",
              displayfields: "",
            },
            {
              value: "productrental_leasing",
              text: "Product Rental & Leasing",
              displayfields: "",
            },
            {
              value: "transportation_logistics",
              text: "Transportation & Logistics",
              displayfields: "",
            },
            {
              value: "business_auditservices",
              text: "Business & Audit Services",
              displayfields: "",
            },
            {
              value: "financial_legalservices",
              text: "Financial & Legal Services",
              displayfields: "",
            },
            {
              value: "education_training",
              text: "Education & Training",
              displayfields: "",
            },
            {
              value: "traveltourism_hotels",
              text: "Travel, Tourism & Hotels",
              displayfields: "",
            },
            {
              value: "callcenter_bposervices",
              text: "Call Center & BPO Services",
              displayfields: "",
            },
            {
              value: "bicyclerickshaw_spares",
              text: "Bicycle, Rickshaw & Spares",
              displayfields: "",
            },
            {
              value: "r_dandtestinglabs",
              text: "R&D and Testing Labs",
              displayfields: "",
            },
            {
              value: "architecture_interiors",
              text: "Architecture & Interiors",
              displayfields: "",
            },
            {
              value: "hrplanning_recruitment",
              text: "HR Planning & Recruitment",
              displayfields: "",
            },
            {
              value: "railshipping_aviation",
              text: "Rail, Shipping & Aviation",
              displayfields: "",
            },
            {
              value: "housekeepingservices",
              text: "House Keeping Services",
              displayfields: "",
            },
            {
              value: "leatherproducts",
              text: "Leather Products",
              displayfields: "",
            },
            {
              value: "contractors_freelancers",
              text: "Contractors & Freelancers",
              displayfields: "",
            },
            {
              value: "electronicscomponents",
              text: "Electronics Components",
              displayfields: "",
            },
            {
              value: "electricalequipment",
              text: "Electrical Equipment",
              displayfields: "",
            },
            {
              value: "hospitalclinic_consultation",
              text: "Hospital,Clinic & Consultation",
              displayfields: "",
            },
          ],
        },
        {
          key: "group",
          type: "products",
          defaultfields: true,
          isactive: true,
          required: false,
          maxentries: "10",
          label: "Products",
          name: "products",
          id: "products",
          header: "Group Data",
          taborder: 2,
          groupfields: [
            {
              key: "file",
              filetype: "image",
              required: true,
              maxupload: "1",
              label: "Images",
              name: "productimages",
              id: "productimages",
            },
            {
              key: "dropdown",
              required: true,
              label: "Category",
              name: "productcategory",
              id: "productcategory",
              options: [],
            },
            {
              key: "dropdown",
              required: true,
              label: "Sub-Category",
              name: "productsubcategory",
              id: "productsubcategory",
              options: [],
            },
            {
              key: "textinput",
              required: true,
              maxlen: "250",
              label: "Title",
              name: "producttitle",
              id: "producttitle",
            },
            {
              key: "textarea",
              required: true,
              maxlen: "1000",
              label: "About",
              name: "productinfo",
              id: "productinfo",
            },
          ],
        },
        {
          key: "file",
          filetype: "image",
          defaultfields: true,
          isactive: true,
          required: false,
          maxupload: "10",
          label: "Gallery Images",
          name: "galleryimages",
          id: "galleryimages",
          maxuploadsize: 100,
          header: "File",
          taborder: 3,
        },
        {
          key: "file",
          filetype: "video",
          defaultfields: true,
          isactive: true,
          required: false,
          maxupload: "10",
          label: "Gallery Videos",
          name: "galleryvideos",
          id: "galleryvideos",
          maxuploadsize: 100,
          header: "File",
          taborder: 4,
        },
        {
          key: "file",
          filetype: "document",
          defaultfields: true,
          isactive: true,
          required: false,
          maxupload: "5",
          label: "Other Documents",
          name: "documents",
          id: "documents",
          maxuploadsize: 100,
          header: "File",
          taborder: 5,
        },
        {
          key: "group",
          type: "coupons",
          defaultfields: true,
          isactive: true,
          required: false,
          maxentries: "2",
          label: "Coupons",
          name: "coupons",
          id: "coupons",
          header: "Group Data",
          taborder: 6,
          groupfields: [
            {
              key: "textinput",
              required: true,
              maxlen: "250",
              label: "Title",
              name: "coupontitle",
              id: "coupontitle",
            },
            {
              key: "textarea",
              required: true,
              maxlen: "1000",
              label: "About",
              name: "couponabout",
              id: "couponabout",
            },
            {
              key: "textinput",
              required: true,
              maxlen: "250",
              label: "Coupon Code",
              name: "couponecode",
              id: "couponecode",
            },
            {
              key: "datepicker",
              required: true,
              label: "Valid Till",
              name: "couponvalidtill",
              id: "couponvalidtill",
            },
          ],
        },
        {
          key: "group",
          type: "deals",
          defaultfields: true,
          isactive: true,
          required: false,
          maxentries: "2",
          label: "Deals",
          name: "deals",
          id: "deals",
          header: "Group Data",
          taborder: 7,
          groupfields: [
            {
              key: "textinput",
              required: true,
              maxlen: "250",
              label: "Title",
              name: "dealtitle",
              id: "dealtitle",
            },
            {
              key: "textarea",
              required: true,
              maxlen: "1000",
              label: "About",
              name: "dealabout",
              id: "dealabout",
            },
            {
              key: "datepicker",
              required: true,
              label: "Valid Till",
              name: "dealvalidtill",
              id: "dealvalidtill",
            },
          ],
        },
        {
          key: "textinput",
          defaultfields: true,
          isactive: true,
          required: false,
          maxlen: "250",
          label: "Email",
          name: "email",
          id: "email",
          header: "Input",
          taborder: 8,
        },
        {
          key: "textinput",
          defaultfields: true,
          isactive: false,
          required: false,
          maxlen: "20",
          label: "Phone Number",
          name: "phonenumber",
          id: "phonenumber",
          header: "Input",
          taborder: 9,
        },
        {
          key: "textinput",
          defaultfields: true,
          isactive: true,
          required: false,
          maxlen: "250",
          label: "Contact Person",
          name: "contactperson",
          id: "contactperson",
          header: "Input",
          taborder: 10,
        },
        {
          key: "textarea",
          defaultfields: true,
          isactive: true,
          required: false,
          maxlen: "500",
          label: "Address",
          name: "address",
          id: "address",
          header: "Textarea",
          taborder: 11,
        },
        {
          key: "textinput",
          defaultfields: true,
          isactive: true,
          required: false,
          maxlen: "250",
          label: "Website",
          name: "weblink",
          id: "weblink",
          header: "Input",
          taborder: 12,
        },
        {
          key: "textinput",
          defaultfields: true,
          isactive: true,
          required: false,
          maxlen: "250",
          label: "Facebook",
          name: "facebook",
          id: "facebook",
          header: "Input",
          taborder: 13,
        },
        {
          key: "textinput",
          defaultfields: true,
          isactive: true,
          required: false,
          maxlen: "250",
          label: "Twitter",
          name: "twitter",
          id: "twitter",
          header: "Input",
          taborder: 14,
        },
        {
          key: "textinput",
          defaultfields: true,
          isactive: true,
          required: false,
          maxlen: "250",
          label: "Linkedin",
          name: "linkedin",
          id: "linkedin",
          header: "Input",
          taborder: 15,
        },
        {
          key: "textinput",
          defaultfields: true,
          isactive: true,
          required: false,
          maxlen: "250",
          label: "Instagram",
          name: "instagram",
          id: "instagram",
          header: "Input",
          taborder: 16,
        },
        {
          key: "textinput",
          defaultfields: true,
          isactive: true,
          required: false,
          maxlen: "250",
          label: "Whatsapp",
          name: "whatsapp",
          id: "whatsapp",
          header: "Input",
          taborder: 17,
        },
      ];
      formName = "Exhibitor Form";
    } else if (e === "sponsor") {
      fixedObj = [
        {
          key: "dropdown",
          defaultfields: "fixed",
          required: false,
          label: "Category",
          name: "category",
          id: "category",
          hasCondition: false,
          header: "Dropdown",
          options: [
            { value: "1", text: "Platinum", displayfields: "" },
            { value: "2", text: "Gold", displayfields: "" },
            { value: "3", text: "Silver", displayfields: "" },
            { value: "4", text: "Bronze", displayfields: "" },
          ],
        },
        {
          key: "file",
          defaultfields: "fixed",
          filetype: "image",
          required: false,
          maxupload: "1",
          label: "Upload Banner",
          name: "banner",
          id: "banner",
          header: "File",
          note: "(Recommended size: 1147px * 368px)",
          maxuploadsize: 100,
        },
        {
          key: "file",
          defaultfields: "fixed",
          filetype: "image",
          required: false,
          maxupload: "1",
          label: "Upload Logo",
          name: "logo",
          id: "logo",
          header: "File",
          note: "(Recommended size: 350px * 200px)",
          maxuploadsize: 100,
        },
        {
          key: "textinput",
          defaultfields: "fixed",
          required: true,
          maxlen: "250",
          label: "Sponsor/Company Name",
          name: "name",
          id: "name",
          header: "Input",
        },
        {
          key: "textarea",
          defaultfields: "fixed",
          required: false,
          maxlen: "1000",
          label: "About/Bio",
          name: "about",
          id: "about",
          header: "Textarea",
        },
      ];
      newObj = [
        {
          key: "dropdown",
          defaultfields: true,
          isactive: true,
          required: false,
          label: "Industry",
          name: "industry",
          id: "industry",
          header: "Dropdown",
          hasCondition: false,
          taborder: 1,
          options: [
            {
              value: "drugs_pharmaceuticals",
              text: "Drugs & Pharmaceuticals",
              displayfields: "",
            },
            {
              value: "hospital_diagnostics",
              text: "Hospital & Diagnostics",
              displayfields: "",
            },
            {
              value: "food_beverages",
              text: "Food & Beverages",
              displayfields: "",
            },
            {
              value: "industrialplants_machinery",
              text: "Industrial Plants & Machinery",
              displayfields: "",
            },
            {
              value: "industrialsupplies",
              text: "Industrial Supplies",
              displayfields: "",
            },
            {
              value: "building_construction",
              text: "Building & Construction",
              displayfields: "",
            },
            {
              value: "apparel_garments",
              text: "Apparel & Garments",
              displayfields: "",
            },
            {
              value: "electronics_electrical",
              text: "Electronics & Electrical",
              displayfields: "",
            },
            {
              value: "packagingmachines_goods",
              text: "Packaging Machines & Goods",
              displayfields: "",
            },
            {
              value: "chemicalsdyes_solvents",
              text: "Chemicals, Dyes & Solvents",
              displayfields: "",
            },
            {
              value: "mechanicalparts_spares",
              text: "Mechanical Parts & Spares",
              displayfields: "",
            },
            {
              value: "labinstruments_supplies",
              text: "Lab Instruments & Supplies",
              displayfields: "",
            },
            {
              value: "furniture_supplies",
              text: "Furniture & Supplies",
              displayfields: "",
            },
            {
              value: "automobileparts_spares",
              text: "Automobile, Parts & Spares",
              displayfields: "",
            },
            {
              value: "agriculture_farming",
              text: "Agriculture & Farming",
              displayfields: "",
            },
            {
              value: "housewares_supplies",
              text: "Housewares & Supplies",
              displayfields: "",
            },
            {
              value: "metalsalloys_Minerals",
              text: "Metals, Alloys & Minerals",
              displayfields: "",
            },
            {
              value: "hand_machinetools",
              text: "Hand & Machine Tools",
              displayfields: "",
            },
            {
              value: "handicrafts_decoratives",
              text: "Handicrafts & Decoratives",
              displayfields: "",
            },
            {
              value: "kitchenutensils_appliances",
              text: "Kitchen Utensils & Appliances",
              displayfields: "",
            },
            {
              value: "textilesyarn_fabrics",
              text: "Textiles, Yarn & Fabrics",
              displayfields: "",
            },
            {
              value: "books_stationery",
              text: "Books & Stationery",
              displayfields: "",
            },
            {
              value: "cosmetics_personalcare",
              text: "Cosmetics & Personal Care",
              displayfields: "",
            },
            {
              value: "hometextile_furnishing",
              text: "Home Textile & Furnishing",
              displayfields: "",
            },
            {
              value: "engineeringservices",
              text: "Engineering Services",
              displayfields: "",
            },
            {
              value: "gemsjewelry_astrology",
              text: "Gems, Jewelry & Astrology",
              displayfields: "",
            },
            {
              value: "computer_itsolutions",
              text: "Computer & IT Solutions",
              displayfields: "",
            },
            {
              value: "fashionaccessories_gear",
              text: "Fashion Accessories & Gear",
              displayfields: "",
            },
            {
              value: "herbal_ayurvedicproduct",
              text: "Herbal & Ayurvedic Product",
              displayfields: "",
            },
            {
              value: "securitysystems_services",
              text: "Security Systems & Services",
              displayfields: "",
            },
            {
              value: "sportsgoodstoys_games",
              text: "Sports Goods, Toys & Games",
              displayfields: "",
            },
            {
              value: "telecomequipment_goods",
              text: "Telecom Equipment & Goods",
              displayfields: "",
            },
            {
              value: "paper_paperproducts",
              text: "Paper & Paper Products",
              displayfields: "",
            },
            {
              value: "bagsbelts_wallets",
              text: "Bags, Belts & Wallets",
              displayfields: "",
            },
            {
              value: "mediapr_publishing",
              text: "Media, PR & Publishing",
              displayfields: "",
            },
            {
              value: "marblegranite_stones",
              text: "Marble, Granite & Stones",
              displayfields: "",
            },
            {
              value: "eventplanner_organizer",
              text: "Event Planner & Organizer",
              displayfields: "",
            },
            {
              value: "it_telecomservices",
              text: "IT & Telecom Services",
              displayfields: "",
            },
            {
              value: "productrental_leasing",
              text: "Product Rental & Leasing",
              displayfields: "",
            },
            {
              value: "transportation_logistics",
              text: "Transportation & Logistics",
              displayfields: "",
            },
            {
              value: "business_auditservices",
              text: "Business & Audit Services",
              displayfields: "",
            },
            {
              value: "financial_legalservices",
              text: "Financial & Legal Services",
              displayfields: "",
            },
            {
              value: "education_training",
              text: "Education & Training",
              displayfields: "",
            },
            {
              value: "traveltourism_hotels",
              text: "Travel, Tourism & Hotels",
              displayfields: "",
            },
            {
              value: "callcenter_bposervices",
              text: "Call Center & BPO Services",
              displayfields: "",
            },
            {
              value: "bicyclerickshaw_spares",
              text: "Bicycle, Rickshaw & Spares",
              displayfields: "",
            },
            {
              value: "r_dandtestinglabs",
              text: "R&D and Testing Labs",
              displayfields: "",
            },
            {
              value: "architecture_interiors",
              text: "Architecture & Interiors",
              displayfields: "",
            },
            {
              value: "hrplanning_recruitment",
              text: "HR Planning & Recruitment",
              displayfields: "",
            },
            {
              value: "railshipping_aviation",
              text: "Rail, Shipping & Aviation",
              displayfields: "",
            },
            {
              value: "housekeepingservices",
              text: "House Keeping Services",
              displayfields: "",
            },
            {
              value: "leatherproducts",
              text: "Leather Products",
              displayfields: "",
            },
            {
              value: "contractors_freelancers",
              text: "Contractors & Freelancers",
              displayfields: "",
            },
            {
              value: "electronicscomponents",
              text: "Electronics Components",
              displayfields: "",
            },
            {
              value: "electricalequipment",
              text: "Electrical Equipment",
              displayfields: "",
            },
            {
              value: "hospitalclinic_consultation",
              text: "Hospital,Clinic & Consultation",
              displayfields: "",
            },
          ],
        },
        {
          key: "file",
          filetype: "image",
          defaultfields: true,
          isactive: true,
          required: false,
          maxupload: "10",
          label: "Gallery Images",
          name: "galleryimages",
          id: "galleryimages",
          header: "File",
          maxuploadsize: 100,
          taborder: 2,
        },
        {
          key: "file",
          filetype: "video",
          defaultfields: true,
          isactive: true,
          required: false,
          maxupload: "10",
          label: "Gallery Videos",
          name: "galleryvideos",
          id: "galleryvideos",
          header: "File",
          maxuploadsize: 100,
          taborder: 3,
        },
        {
          key: "file",
          filetype: "document",
          defaultfields: true,
          isactive: true,
          required: false,
          maxupload: "5",
          label: "Other Documents",
          name: "documents",
          id: "documents",
          header: "File",
          maxuploadsize: 100,
          taborder: 4,
        },
        {
          key: "textinput",
          defaultfields: true,
          isactive: true,
          required: false,
          maxlen: "250",
          label: "Video Link",
          name: "videourl",
          id: "videourl",
          header: "Input",
        },
        {
          key: "textinput",
          defaultfields: true,
          isactive: true,
          required: false,
          maxlen: "250",
          label: "Contact Person",
          name: "sponsor_spoc",
          id: "sponsor_spoc",
          header: "Input",
        },
        {
          key: "textinput",
          defaultfields: true,
          isactive: true,
          required: false,
          maxlen: "250",
          label: "Email",
          name: "sponsoremail",
          id: "sponsoremail",
          header: "Input",
        },
        {
          key: "textinput",
          defaultfields: true,
          isactive: false,
          required: false,
          maxlen: "20",
          label: "Phone Number",
          name: "phonenumber",
          id: "phonenumber",
          header: "Input",
          taborder: 5,
        },
        {
          key: "textarea",
          defaultfields: true,
          isactive: true,
          required: false,
          maxlen: "500",
          label: "Address",
          name: "address",
          id: "address",
          header: "Textarea",
          taborder: 6,
        },
        {
          key: "textinput",
          defaultfields: true,
          isactive: true,
          required: false,
          maxlen: "250",
          label: "Website",
          name: "weblink",
          id: "weblink",
          header: "Input",
          taborder: 7,
        },
        {
          key: "textinput",
          defaultfields: true,
          isactive: true,
          required: false,
          maxlen: 250,
          label: "Facebook",
          name: "facebook",
          id: "facebook",
          header: "Input",
          taborder: 8,
        },
        {
          key: "textinput",
          defaultfields: true,
          isactive: true,
          required: false,
          maxlen: "250",
          label: "Twitter",
          name: "twitter",
          id: "twitter",
          header: "Input",
          taborder: 9,
        },
        {
          key: "textinput",
          defaultfields: true,
          isactive: true,
          required: false,
          maxlen: "250",
          label: "Linkedin",
          name: "linkedin",
          id: "linkedin",
          header: "Input",
          taborder: 10,
        },
        {
          key: "textinput",
          defaultfields: true,
          isactive: true,
          required: false,
          maxlen: "250",
          label: "Instagram",
          name: "instagram",
          id: "instagram",
          header: "Input",
          taborder: 11,
        },
        {
          key: "textinput",
          defaultfields: true,
          isactive: true,
          required: false,
          maxlen: "250",
          label: "Whatsapp",
          name: "whatsapp",
          id: "whatsapp",
          header: "Input",
          taborder: 12,
        },
      ];
      formName = "Sponsor Form";
    } else {
      // Default attendee form
      fixedObj = [
        {
          key: "textinput",
          defaultfields: "fixed",
          required: false,
          maxlen: "250",
          label: "Email",
          name: "email",
          id: "email",
          header: "Input",
        },
        {
          key: "textinput",
          defaultfields: "fixed",
          required: false,
          maxlen: "250",
          label: "First Name",
          name: "firstname",
          id: "firstname",
          header: "Input",
        },
        {
          key: "textinput",
          defaultfields: "fixed",
          required: false,
          maxlen: "250",
          label: "Last Name",
          name: "lastname",
          id: "lastname",
          header: "Input",
        },
        {
          key: "interestcheckboxes",
          defaultfields: "fixed",
          required: false,
          label: "Interest",
          name: "interest",
          id: "interest",
          header: "Multi Select",
          options: [
            { value: "software", text: "Software" },
            { value: "automation", text: "Automation" },
            { value: "gaming", text: "Gaming" },
            { value: "it", text: "IT" },
          ],
        },
      ];
      newObj = [
        {
          key: "textarea",
          defaultfields: true,
          isactive: true,
          required: false,
          maxlen: "2000",
          label: "Bio",
          name: "biography",
          id: "biography",
          header: "Textarea",
          taborder: 1,
        },
        {
          key: "textinput",
          defaultfields: true,
          isactive: true,
          required: false,
          maxlen: "250",
          label: "Company",
          name: "company",
          id: "company",
          header: "Input",
          taborder: 2,
        },
        {
          key: "textinput",
          defaultfields: true,
          isactive: true,
          required: false,
          maxlen: "250",
          label: "Designation",
          name: "designation",
          id: "designation",
          header: "Input",
          taborder: 3,
        },
        {
          key: "checkboxes",
          defaultfields: true,
          isactive: true,
          required: false,
          label: "Interest",
          name: "interest",
          id: "interest",
          header: "Checkbox",
          taborder: 4,
          options: [
            { value: "software", text: "Software" },
            { value: "automation", text: "Automation" },
            { value: "gaming", text: "Gaming" },
            { value: "it", text: "IT" },
          ],
        },
        {
          key: "textinput",
          defaultfields: true,
          isactive: false,
          required: false,
          maxlen: "250",
          label: "Phone Number",
          name: "phonenumber",
          id: "phonenumber",
          header: "Input",
          taborder: 5,
        },
        {
          key: "textinput",
          defaultfields: true,
          isactive: true,
          required: false,
          maxlen: "250",
          label: "Facebook",
          name: "facebook",
          id: "facebook",
          header: "Input",
          taborder: 6,
        },
        {
          key: "textinput",
          defaultfields: true,
          isactive: true,
          required: false,
          maxlen: "250",
          label: "Twitter",
          name: "twitter",
          id: "twitter",
          header: "Input",
          taborder: 7,
        },
        {
          key: "textinput",
          defaultfields: true,
          isactive: true,
          required: false,
          maxlen: "250",
          label: "Linkedin",
          name: "linkedin",
          id: "linkedin",
          header: "Input",
          taborder: 8,
        },
        {
          key: "singlecheckbox",
          defaultfields: true,
          isactive: true,
          required: false,
          label:
            "Networking/GDPR Consent (This will enable you to share your profile and connect with other users.)",
          name: "isnetworking",
          id: "isnetworking",
          header: "Checkbox",
          taborder: 9,
        },
        {
          key: "singlecheckbox",
          defaultfields: true,
          isactive: true,
          required: false,
          label: "Terms & Conditions",
          name: "termsconditions",
          id: "termsconditions",
          header: "Checkbox",
          taborder: 10,
        },
      ];
      formName = "Attendee Form";
      e = "checkout";
    }

    this.props.dynamicFormModal({
      key: "add",
      showModal: true,
      category: e,
      fixedFields: fixedObj,
    });
    this.props.updateFomeName(formName);
    this.props.updateFormList(newObj, [], "new");
  };

  renderList = () => {
    let pageDataLength = this.props.formBuildeList.resource.length;
    let { pageNumber } = this.state;
    return _.map(this.props.formBuildeList.resource, (form) => {
      return (
        <FormList
          key={form.formid}
          formList={form}
          pagination={this.paginationCallback}
          pageDataLength={pageDataLength}
          currentPage={pageNumber}
        />
      );
    });
  };

  paginationCallback = (pageNumber) => {
    this.props.fetchFormBuilder(
      this.props.session,
      pageNumber,
      (callback) => {}
    );
    this.setState({ ...this.state, pageNumber });
  };

  callbackForm = (res) => {
    this.paginationCallback(1);
  };

  /**
   * =============================================================================================
   */
  render() {
    let { formBuilderModal, deviceSize } = this.props;

    return (
      <div>
        <div className="content-header-bar">
          <div className="pull-left h-100 vertical-align-center">
            <div>
              <div className="tickets-heading">
                {LocaleStrings.ticket_submenu_title7}
              </div>
              <div className="custom-text2-secondary-normal subtext-tabhidden">
                {LocaleStrings.ticket_submenu_description7}
              </div>
            </div>
          </div>
          <div
            className="pull-right h-100 vertical-align-center create-formtab"
            style={{ marginLeft: "auto" }}
          >
            {DEVELOPMENT_TYPE === "koachify" ? (
              ""
            ) : (
              <>
                <div className="dropdown-btn-container">
                  <DropdownButton
                    className="dropdown-blue-btn"
                    id="dropdown-basic-2"
                    title={LocaleStrings.button_create_dynamic_form}
                    key="1"
                    nocaret="true"
                  >
                    <Dropdown.Item
                      eventKey="checkout"
                      onClick={() => this.openModal("checkout")}
                    >
                      {LocaleStrings.tickets_checkout_form_add_option1}
                    </Dropdown.Item>
                    <Dropdown.Item
                      eventKey="exhibitor"
                      onClick={() => this.openModal("exhibitor")}
                    >
                      {LocaleStrings.tickets_checkout_form_add_option2}
                    </Dropdown.Item>
                    <Dropdown.Item
                      eventKey="sponsor"
                      onClick={() => this.openModal("sponsor")}
                    >
                      {LocaleStrings.tickets_checkout_form_add_option3}
                    </Dropdown.Item>
                  </DropdownButton>
                </div>
              </>
            )}
          </div>
        </div>

        <div
          className="panel-body scrollable-content"
          style={{ height: deviceSize.height - screenHeightLeftFromTop }}
        >
          {this.state.loading ? (
            <div className="loader-container">
              <Loader />
              <div className="loader-info">{this.state.desc}</div>
            </div>
          ) : (
            <>
              {this.props.formBuildeList.resource &&
              this.props.formBuildeList.resource.length > 0 ? (
                <div className="sponsor-table">
                  <table className="table">
                    <thead>
                      <tr>
                        {/* <th>
                      {LocaleStrings.tickets_checkout_form_table_list_formno}
                    </th> */}
                        <th>
                          {
                            LocaleStrings.tickets_checkout_form_table_list_form_name
                          }
                        </th>
                        {/* <th>
                      {
                        LocaleStrings.tickets_checkout_form_table_list_form_version
                      }
                    </th> */}
                        <th>
                          {
                            LocaleStrings.tickets_checkout_form_table_list_form_type
                          }
                        </th>
                        <th className="checkout-form-action-col-p">
                          {
                            LocaleStrings.tickets_checkout_form_table_list_action
                          }
                        </th>
                      </tr>
                    </thead>
                    <tbody className="tbody-background">
                      {this.renderList()}
                    </tbody>
                  </table>
                  {this.props.formBuildeList.count > itemCount ? (
                    <Pagination
                      activePage={this.state.pageNumber}
                      itemsCountPerPage={itemCount}
                      totalItemsCount={this.props.formBuildeList.count}
                      pageRangeDisplayed={10}
                      onChange={this.paginationCallback}
                      style={{ float: "right" }}
                    />
                  ) : null}
                </div>
              ) : (
                <NoContent contentType={NO_FORMLIST} />
              )}
            </>
          )}
        </div>

        {formBuilderModal &&
        formBuilderModal.showModal &&
        formBuilderModal.key === "add" ? (
          <AddForm calledFrom={this.callbackForm} />
        ) : (
          ""
        )}
        {formBuilderModal &&
        formBuilderModal.showModal &&
        formBuilderModal.key === "edit" ? (
          <EditForm calledFrom={this.callbackForm} />
        ) : (
          ""
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session,
    deviceSize: state.deviceSize,
    formBuildeList: state.formBuildeList,
    formBuilderModal: state.formBuilderModal,
  };
}

export default connect(mapStateToProps, {
  dynamicFormModal,
  updateFomeName,
  updateFormList,
  fetchFormBuilder,
  fetchSettings,
  fetchTickets,
  fetchUsersCategory,
  fetchCountries,
})(FormBuilder);
